import React from "react";

// Logo de marca de Agent Company OS: insignia cuadrada con degradado violeta
// y un rayo blanco. Vectorial (SVG en línea), nítido a cualquier tamaño.
// Uso: <BrandMark className="w-8 h-8" />
export default function BrandMark({ className = "w-8 h-8", radius = 7 }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={`${className} shrink-0`}
      role="img"
      aria-label="Agent Company OS"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="brandmark-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#8B7CF8" />
          <stop offset="1" stopColor="#6D5CE0" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx={radius} fill="url(#brandmark-grad)" />
      <path d="M17.6 4.8 L8.8 18.2 h5.1 l-1.7 9 L23.2 12.9 h-5.1 z" fill="#ffffff" />
    </svg>
  );
}
